<template>
  <main>
    <div class="whiteBackground p-3">
      <b-container>
        <div class="nav-style">
          <b-button
            class="pl-0"
            style="font-weight:400;font-size:16px;line-height: 22px;"
            variant="link"
            @click="$router.push({ name: 'support' })"
          >
            <b-icon icon="chevron-left"></b-icon>&nbsp;Back To Support
          </b-button>
        </div>
        <section id="header">
          <b-row class="mt-2 mb-4">
            <b-col cols="12"
              ><p class="myStudiesHeader">Pfizer Guide to Application Support</p></b-col
            >
          </b-row>
          <app-support-header />
        </section>
        <hr class="solid my-4" />
        <section id="helpTopics" class="mb-4">
          <multiselect
            v-model="selected"
            :allow-empty="false"
            :disabled="loading"
            :options="helpTopics"
            :searchable="true"
            deselect-label="Can't remove this value"
            label="title"
            placeholder="Select an application"
            track-by="title"
            @input="goToApplication"
          ></multiselect>
        </section>
      </b-container>
    </div>
    <div id="topic-content">
      <router-view v-if="selected" :topic="selected"></router-view>
      <div v-else class="text-center my-5">
        <div>
          <b-img :src="dropDownIcon" fluid></b-img>
        </div>
        <div>
          <b-img :src="image" fluid></b-img>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import AppSupportHeader from './AppSupportHeader';
  import AppSupportExostarTable from './AppSupportExostarTable';
  import AppSupportApplicationsTable from './AppSupportApplicationsTable';
  import img from '../../../../images/selectHelpTopic.png';
  import dropDownIcon from '../../../../images/dropDownIcon.png';

  export default {
    name: 'pfizer-application-support',
    components: { AppSupportApplicationsTable, AppSupportExostarTable, AppSupportHeader },
    data() {
      return {
        image: img,
        dropDownIcon: dropDownIcon,
        selected: null,
        loading: false,
        helpTopics: [],
      };
    },
    created() {
      this.getHelpTopics();
    },
    watch: {
      $route() {
        this.checkForExistingId();
      },
    },
    methods: {
      goToApplication(event) {
        if (event) {
          this.$router.push({
            name: 'pfizer-application-support-help-topic',
            params: {
              topicId: event.id,
            },
          });
        }
      },
      async getHelpTopics() {
        try {
          this.loading = true;
          let response = await axios.get(`/api/get-help-topics`, {
            params: { category: 'application-support', 'include-body': 1, status: 'PUBLISHED' },
          });
          if (response.status !== 204) {
            this.helpTopics = response.data['items'];
            this.helpTopics.sort(
              (firstItem, secondItem) => firstItem.ordering - secondItem.ordering,
            );
            this.checkForExistingId();
          }
        } catch (error) {
          this.$bvToast.toast(`Server is not responding, please try again later`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'danger',
          });
        }
        this.loading = false;
      },
      checkForExistingId() {
        if (this.$route.params['topicId'] !== undefined) {
          this.selected = this.helpTopics.find(
            element => element.id === this.$route.params['topicId'],
          );
        }
      },
    },
  };
</script>
